<template>
    <div class="widget-view ql-font-lato" :data-uuid="settings.uuid" :style="widgetStyle">
        <widget-wrapper :settings="settings">
            <component
                :settings="block"
                :is="resolveBlock(block)"
                :blocks-map="blocksMap"
                :elements-map="elementsMap"
                :key="index"
                v-for="(block, index) in children"
            ></component>
            <component :is="'style'">
                {{ childrenStyle }}
            </component>
        </widget-wrapper>
    </div>
</template>

<script>
import WidgetBlockContainer from "./blocks/WidgetBlockContainer.vue"
import WidgetCustomBlock from "./blocks/WidgetCustomBlock.vue"
import WidgetForm from "./blocks/WidgetForm.vue"
import WidgetButton from "./elements/WidgetButton.vue"
import WidgetLink from "./elements/WidgetLink.vue"
import WidgetImage from "./elements/WidgetImage.vue"
import WidgetTextInline from "./elements/WidgetTextInline.vue"
import WidgetField from "./elements/WidgetField.vue"
import WidgetStepBlock from "./blocks/WidgetStepBlock.vue"
import WidgetWrapper from "./WidgetWrapper.vue"
import WidgetRadioFormGroup from "./elements/WidgetRadioFormGroup.vue"
import WidgetHtmlBlock from "./blocks/WidgetHtmlBlockInline.vue"
import WidgetTimer from "./elements/WidgetTimer.vue"

const styles = `@font-face{font-family:Comfortaa;src:local('Comfortaa Bold'),url('https://kwiga.com/build/assets/Comfortaa-Bold.c770d14f.woff2') format('woff2');font-weight:700;font-style:normal}@font-face{font-family:Comfortaa;src:url('Comfortaa-Regular.eot');src:local('Comfortaa Regular'),url('https://kwiga.com/build/assets/Comfortaa-Regular.5a271cd7.woff2') format('woff2');font-weight:400;font-style:normal}@font-face{font-family:Inter;src:local('Inter Regular'),local('Inter-Regular'),url('https://kwiga.com/build/assets/Inter-Regular.41ab0f70.ttf') format('truetype');font-weight:400;font-style:normal;font-display:swap}@font-face{font-family:Inter;src:local('Inter Bold'),url('https://kwiga.com/build/assets/Inter-Bold.85434d8a.woff2') format('woff2');font-weight:700;font-style:normal;font-display:swap}@font-face{font-family:lato;src:url(https://kwiga.com/build/assets/Lato-Regular.a506a2f0.woff2) format("woff2");font-weight:400;font-style:normal}@font-face{font-family:lato;src:url(https://kwiga.com/build/assets/Lato-Bold.79af3777.woff2) format("woff2");font-weight:700;font-style:normal}@font-face{font-family:arial;src:url(https://kwiga.com/build/assets/Arial-Bold.90e12ba2.woff2) format("woff2");font-weight:700;font-style:normal}@font-face{font-family:arial;src:url(https://kwiga.com/build/assets/Arial.5341c3ea.woff2) format("woff2");font-weight:400;font-style:normal}@font-face{font-family:comic sans ms;src:url(https://kwiga.com/build/assets/ComicSansMS-Bold.e186926e.woff2) format("woff2");font-weight:700;font-style:normal}@font-face{font-family:comic sans ms;src:url(https://kwiga.com/build/assets/ComicSansMS.5a6158bc.woff2) format("woff2");font-weight:400;font-style:normal}@font-face{font-family:courier new;src:url(https://kwiga.com/build/assets/CourierStd-Bold.7dbe7390.woff2) format("woff2");font-weight:700;font-style:normal}@font-face{font-family:courier new;src:url(https://kwiga.com/build/assets/CourierStd.9c464be2.woff2) format("woff2");font-weight:400;font-style:normal}@font-face{font-family:georgia;src:url(https://kwiga.com/build/assets/Georgia-Bold.20c797db.woff2) format("woff2");font-weight:700;font-style:normal}@font-face{font-family:georgia;src:url(https://kwiga.com/build/assets/Georgia.4b85d763.woff2) format("woff2");font-weight:400;font-style:normal}@font-face{font-family:tahoma;src:local("tahoma-bold"),url(https://kwiga.com/build/assets/Tahoma-Bold.684f08f6.woff2) format("woff2");font-weight:700;font-style:normal}@font-face{font-family:tahoma;src:url(https://kwiga.com/build/assets/Tahoma.44ee17f2.woff2) format("woff2");font-weight:400;font-style:normal}@font-face{font-family:times new roman;src:url(https://kwiga.com/build/assets/TimesNewRomanMTStd-Bold.ad180666.woff2) format("woff2");font-weight:700;font-style:normal}@font-face{font-family:times new roman;src:url(https://kwiga.com/build/assets/TimesNewRomanMTStd.dda5b6c4.woff2) format("woff2");font-weight:400;font-style:normal}@font-face{font-family:trebuchet ms;src:url(https://kwiga.com/build/assets/TrebuchetMS-Bold.83bd9349.woff) format("woff");font-weight:700;font-style:normal}@font-face{font-family:trebuchet ms;src:url(https://kwiga.com/build/assets/TrebuchetMS.0797c49c.woff) format("woff");font-weight:400;font-style:normal}@font-face{font-family:verdana;src:url(https://kwiga.com/build/assets/Verdana-Bold.1dbb8dca.woff2) format("woff2");font-weight:700;font-style:normal}@font-face{font-family:verdana;src:url(https://kwiga.com/build/assets/Verdana.244e182b.woff2) format("woff2");font-weight:400;font-style:normal}.ql-align-center{text-align:center}.ql-align-right{text-align:right}.ql-align-left{text-align:left}.ql-font-comic{font-family:comic sans ms,marker felt-thin,arial,sans-serif!important}.ql-font-lato{font-family:lato,sans-serif!important}.ql-font-arial{font-family:arial,helvetica neue,helvetica,sans-serif!important}.ql-font-courier{font-family:courier new,courier,lucida sans typewriter,lucida typewriter,monospace!important}.ql-font-georgia{font-family:georgia,times,times new roman,serif}.ql-font-impact{font-family:impact,helvetica neue,helvetica,sans-serif!important}.ql-font-tahoma{font-family:tahoma,verdana,segoe,sans-serif}.ql-font-times{font-family:times new roman,times,baskerville,georgia,serif}.ql-font-trebuchet{font-family:trebuchet ms,lucida grande,lucida sans unicode,lucida sans,tahoma,sans-serif}.ql-font-verdana{font-family:verdana,geneva,sans-serif}.text-view img,.text-view span{max-width:100%;display: inline}.text-view{font-size:1rem;white-space:break-spaces}.text-view table,.text-view td,.text-view th{padding:10px;border:1px solid #151515}@media (max-width:840px){.text-view.tablet-hidden{display:none}}.text-view .iframe-wrapper{position:relative;padding-bottom:60%;overflow:hidden;width:100%;height:auto}.text-view .iframe-wrapper iframe{position:absolute;top:0;left:0;width:100%;height:100%}.text-view a{color:#3965ff;word-wrap:break-word}.text-view img{height:auto}.text-view h1,.text-view h2,.text-view h3,.text-view h4,.text-view p{margin:0;line-height: 1.5}.text-view h1:empty:after,.text-view h2:empty:after,.text-view h3:empty:after,.text-view h4:empty:after,.text-view p:empty:after{content:".";visibility:hidden}.text-view li{margin-bottom:5px}.text-view ul{list-style-type:disc}.text-view ol{list-style-type:decimal}.text-view ol,.text-view ul{padding:0 1rem}.circled-graph {position: relative;}.circled-graph canvas {position: absolute;transform: rotate(180deg);left: 0;top: 0;}.circled-graph svg {z-index: 1;position: absolute;transform: rotate(180deg);left: 0;top: 0;}.circled-graph p {margin: 0;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);font-size: 13px;white-space: nowrap;}`

const blocksMap = {
    CUSTOM: WidgetCustomBlock,
    FORM: WidgetForm,
    STEP: WidgetStepBlock,
    HTML: WidgetHtmlBlock
}

const elementsMap = {
    BUTTON: WidgetButton,
    LINK: WidgetLink,
    IMAGE: WidgetImage,
    TEXT: WidgetTextInline,
    FIELD: WidgetField,
    RADIO_FORM_GROUP: WidgetRadioFormGroup,
    TIMER: WidgetTimer
}

export default {
    components: { WidgetWrapper },
    props: {
        settings: {
            type: Object,
            default: () => {}
        },
        uuid: {
            type: String,
            default: ""
        }
    },
    provide() {
        return {
            uuid: this.uuid
        }
    },
    name: "WidgetViewBuild",
    data() {
        return {
            blocksMap,
            elementsMap
        }
    },
    methods: {
        resolveBlock() {
            return WidgetBlockContainer
        }
    },
    mounted() {
        window.builder_dev_mode = false
    },
    computed: {
        children() {
            return this.settings.children.filter(
                child => !child.hasOwnProperty("hidden") || (child.hasOwnProperty("hidden") && !child.hidden)
            )
        },
        childrenStyle() {
            return styles
        },
        widgetStyle() {
            return {
                lineHeight: 1,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                maxWidth: "100vw"
            }
        }
    }
}
</script>

